export default __webpack_public_path__ + "static/media/Verantoslogos.5c6e115a.svg";